import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { deriveTagColor } from 'libs/tag-style';
import BeeyTag from 'components/BeeyTag';
const getTags = (tagList, teamTags) => {
    const projectTags = teamTags === 'loading'
        ? []
        : tagList.map((tag) => {
            const teamTag = teamTags.list.find((tt) => tt.tag === tag);
            if (teamTag === undefined) {
                return {
                    title: tag,
                    key: tag,
                    color: deriveTagColor(tag),
                    abbreviation: tag.slice(0, 2),
                    isForeign: true,
                    showFullVersion: false,
                };
            }
            return {
                title: teamTag.tag,
                key: teamTag.tag,
                color: teamTag.color,
                abbreviation: teamTag.abbreviation,
                isForeign: false,
                showFullVersion: false,
            };
        });
    return projectTags;
};
const TagList = ({ tagList, teamTags }) => {
    const tags = getTags(tagList, teamTags);
    if (!tags || tags.length === 0) {
        return null;
    }
    return (_jsx(_Fragment, { children: tags.map((tag) => (_jsx(BeeyTag, { tag: tag, isForeign: tag.isForeign, isCheckable: false }, tag.title))) }));
};
export default TagList;
